import React from 'react';
import resolveConfig from 'tailwindcss/resolveConfig';
import { content, theme } from '../../tailwind.config.js';

export const useIsSmallScreen = () => {
  const fullConfig = resolveConfig({ content, theme } as any) as any;
  const mobileBreakpoint = parseInt(
    fullConfig.theme?.screens.sm?.replace('px', ''),
    10,
  );

  // Start as `null` to represent "unknown until mounted"
  const [isSmallScreen, setIsSmallScreen] = React.useState<boolean | null>(
    null,
  );

  React.useEffect(() => {
    // Set the real value once we're on the client
    setIsSmallScreen(window.innerWidth < mobileBreakpoint);

    const handleWindowResize = () => {
      setIsSmallScreen(window.innerWidth < mobileBreakpoint);
    };

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, [mobileBreakpoint]);

  // Return false (not small) until hydration is complete.
  // This matches desktop-first SSR and avoids the fixed-width flash on refresh.
  return isSmallScreen ?? false;
};
